import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const Navdata = () => {
  const history = useNavigate();
  // State
  const [isLuckyTarget, setIsLuckyTarget] = useState(false);
  const [isLuckyTarget1, setIsLuckyTarget1] = useState(false);
  const [isLuckyTarget3, setIsLuckyTarget3] = useState(false);
  const [isRoulette, setIsRoulette] = useState(false);
  const [isSorat, setIsSorat] = useState(false);
  const [isCurrentState, setIsCurrentState] = useState('');

  function updateIconSidebar(e) {
    if (e && e.target && e.target.getAttribute("subitems")) {
      const ul = document.getElementById("two-column-menu");
      const iconItems = ul.querySelectorAll(".nav-icon.active");
      let activeIconItems = [...iconItems];
      activeIconItems.forEach((item) => {
        item.classList.remove("active");
        var id = item.getAttribute("subitems");
        if (document.getElementById(id))
          document.getElementById(id).classList.remove("show");
      });
    }
  }

  useEffect(() => {
    document.body.classList.remove('twocolumn-panel');
    if (isCurrentState !== 'LuckyTarget') {
      setIsLuckyTarget(false);
    }
    if (isCurrentState !== 'LuckyTarget1') {
      setIsLuckyTarget1(false);
    }
    if (isCurrentState !== 'LuckyTarget3') {
      setIsLuckyTarget3(false);
    }
    if (isCurrentState !== 'Roulette') {
      setIsRoulette(false);
    }
    if (isCurrentState !== 'Sorat') {
      setIsSorat(false);
    }
  }, [
    isCurrentState,
    isLuckyTarget,
    isLuckyTarget1,
    isLuckyTarget3,
    isRoulette,
    isSorat
  ]);

  const menuItems = [
    {
      id: "dashboard",
      label: "Dashboard",
      icon: "ri-dashboard-2-line",
      link: "/dashboard",
    },
    {
      id: "lucky-target",
      label: "Lucky Target",
      icon: "ri-gamepad-line",
      link: "/#",
      click: function (e) {
        e.preventDefault();
        setIsLuckyTarget(!isLuckyTarget);
        setIsCurrentState('LuckyTarget');
        updateIconSidebar(e);
      },
      stateVariables: isLuckyTarget,
      subItems: [
        {
          id: "lt-dashboard",
          label: "Dashboard",
          link: "/lucky-target/dashboard",
          parentId: "lucky-target",
          icon: "ri-dashboard-line",
        },
        {
          id: "lt-users",
          label: "Users",
          link: "/lucky-target/users",
          parentId: "lucky-target",
          icon: "ri-user-line",
        },
        {
          id: "lt-joker",
          label: "Joker",
          link: "/lucky-target/joker",
          parentId: "lucky-target",
          icon: "ri-emotion-happy-line",
        },
        {
          id: "lt-transactions",
          label: "Transactions",
          link: "/lucky-target/transactions",
          parentId: "lucky-target",
          icon: "ri-file-chart-line",
        },
      ],
    },
    {
      id: "lucky-target-2",
      label: "Lucky Target 1",
      icon: "ri-gamepad-fill",
      link: "/#",
      click: function (e) {
        e.preventDefault();
        setIsLuckyTarget1(!isLuckyTarget1);
        setIsCurrentState('LuckyTarget1');
        updateIconSidebar(e);
      },
      stateVariables: isLuckyTarget1,
      subItems: [
        {
          id: "lt1-dashboard",
          label: "Dashboard",
          link: "/lucky-target-1/dashboard",
          parentId: "lucky-target-2",
          icon: "ri-dashboard-line",
        },
        {
          id: "lt1-users",
          label: "Users",
          link: "/lucky-target-1/users",
          parentId: "lucky-target-2",
          icon: "ri-user-line",
        },
        {
          id: "lt1-transactions",
          label: "Transactions",
          link: "/lucky-target-1/transactions",
          parentId: "lucky-target-2",
          icon: "ri-file-chart-line",
        },
      ],
    },
    {
      id: "lucky-target-3",
      label: "Lucky Target 2",
      icon: "ri-gamepad-fill",
      link: "/#",
      click: function (e) {
        e.preventDefault();
        setIsLuckyTarget3(!isLuckyTarget3);
        setIsCurrentState('LuckyTarget3');
        updateIconSidebar(e);
      },
      stateVariables: isLuckyTarget3,
      subItems: [
        {
          id: "lt3-dashboard",
          label: "Dashboard",
          link: "/lucky-target-2/dashboard",
          parentId: "lucky-target-3",
          icon: "ri-dashboard-line",
        },
        {
          id: "lt3-users",
          label: "Users",
          link: "/lucky-target-2/users",
          parentId: "lucky-target-3",
          icon: "ri-user-line",
        },
        {
          id: "lt3-transactions",
          label: "Transactions",
          link: "/lucky-target-2/transactions",
          parentId: "lucky-target-3",
          icon: "ri-file-chart-line",
        },
      ],
    },
    {
      id: "american-roulette",
      label: "American Roulette",
      icon: "ri-focus-2-line",
      link: "/#",
      click: function (e) {
        e.preventDefault();
        setIsRoulette(!isRoulette);
        setIsCurrentState('Roulette');
        updateIconSidebar(e);
      },
      stateVariables: isRoulette,
      subItems: [
        {
          id: "ro-dashboard",
          label: "Dashboard",
          link: "/american-roulette/dashboard",
          parentId: "american-roulette",
          icon: "ri-dashboard-line",
        },
        {
          id: "ro-users",
          label: "Users",
          link: "/american-roulette/users",
          parentId: "american-roulette",
          icon: "ri-user-line",
        },
        {
          id: "ro-transactions",
          label: "Transactions",
          link: "/american-roulette/transactions",
          parentId: "american-roulette",
          icon: "ri-file-chart-line",
        },
      ],
    },
    {
      id: "sorat",
      label: "Sorat",
      icon: "ri-ticket-2-line",
      link: "/#",
      click: function (e) {
        e.preventDefault();
        setIsSorat(!isSorat);
        setIsCurrentState('Sorat');
        updateIconSidebar(e);
      },
      stateVariables: isSorat,
      subItems: [
        {
          id: "so-dashboard",
          label: "Dashboard",
          link: "/sorat/dashboard",
          parentId: "sorat",
          icon: "ri-dashboard-line",
        },
        {
          id: "so-users",
          label: "Users",
          link: "/sorat/users",
          parentId: "sorat",
          icon: "ri-user-line",
        },
        {
          id: "so-transactions",
          label: "Transactions",
          link: "/sorat/transactions",
          parentId: "sorat",
          icon: "ri-file-chart-line",
        },
      ],
    },
    {
      id: "day-report",
      label: "Day Report",
      icon: "ri-file-list-3-line",
      link: "/day-report",
    },
    {
      id: "withdrawal",
      label: "Withdrawal",
      icon: "ri-wallet-3-line",
      link: "/withdrawal",
    },
    {
      id: "operators",
      label: "Operators",
      icon: "ri-admin-line",
      link: "/operators",
    },
    {
      id: "settings",
      label: "Settings",
      icon: "ri-settings-3-line",
      link: "/settings",
    },
  ];

  return <React.Fragment>{menuItems}</React.Fragment>;
};

export default Navdata;
